module.exports = __webpack_public_path__ + "img/close-menu-hover.6b91378c.svg";